export default "__VITE_ASSET__CW50cxu9__"